import { useState } from "react";
import checkMarkIcon from "/assets/check-mark.svg";
import arrowDownIcon from "/assets/arrow-down.svg";

export default function InlineSelect({
  label,
  options,
  onChange,
  selectedOptions = [],
}) {
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  const toggleOption = (key) => {
    if (selectedOptions.includes(key)) {
      removeOption(key);
    } else {
      addOption(key);
    }
  };

  const addOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange([...selectedOptions, key]);
  };

  const removeOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange(selectedOptions.filter(o => o != key));
  };

  return (
    <div className="inline-select">
      <div
        className="inline-select__label"
        onClick={() => setIsOptionsVisible(value => !value)}
      >
        <span>{label}</span>

        <img
          src={arrowDownIcon}
          className={`inline-select__arrow-icon ${isOptionsVisible ? "inline-select__arrow-icon--open" : ""}`}
        />
      </div>

      <div className={`inline-select__options ${isOptionsVisible ? "" : "inline-select__options--collapsed"}`}>
        {Object.entries(options).map(([key, value]) => {
          const isSelected = selectedOptions.includes(key);

          return (
            <div
              key={key}
              onClick={() => toggleOption(key)}
              className={`inline-select__option ${isSelected ? "inline-select__option--selected" : ""}`}
            >
              <div className={`inpt-checkbox ${isSelected ? "inpt-checkbox--selected" : ""}`}>
                <img src={checkMarkIcon} />
              </div>

              {value}
            </div>
          );
        })}
      </div>
    </div>
  );
}
